import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--punchline-edit-modal'
    ];

    openEditModal(event) {
        event.preventDefault();
        showPreloader();

        const textarea = document.getElementById('punchline-textarea-readonly');
        const rawValue = textarea ? textarea.textContent.trim() : '';
        const tmp = document.createElement('div');
        tmp.innerHTML = rawValue;
        const data = tmp.textContent || tmp.innerText || '';
        this.profilePunchlineEditModalOutlet.openModal(data);

        hidePreloader()
    }
}
